export default __webpack_public_path__ + "static/media/mid-k-1.14c572b2.jpg";